export const APIs = {
  // COMMON
  baseUrlMainEndpoint:
    process.env.NEXT_PUBLIC_BASE_URL_MAIN_END_POINT ||
    "http://interflight.asiatech.ptp",
  baseUrlInterFlightMainEndpoint:
    process.env.NEXT_PUBLIC_BASE_URL_IFT || "http://interflight.asiatech.ptp",
  baseUrlCDN: process.env.NEXT_PUBLIC_BASE_URL_CDN || "https://fs.snapptrip.co",
  baseUrlTicket:
    process.env.NEXT_PUBLIC_BASE_URL_INTL_TICKET ||
    "http://api.ticket.asiatech.ptp",
  baseUrlImage:
    process.env.NEXT_PUBLIC_BASE_URL_STORE || "https://store.snapptrip.co",
  baseUrlStore:
    process.env.NEXT_PUBLIC_BASE_URL_STORE || "https://store.snapptrip.co",
  baseUrlPlatform:
    process.env.NEXT_PUBLIC_BASE_URL_PLATFORM ||
    "http://platform-api.asiatech.ptp",
  baseUrDomFlight:
    process.env.NEXT_PUBLIC_BASE_URL_FLIGHT || "http://flight.asiatech.ptp",
  baseURLBus:
    process.env.NEXT_PUBLIC_BASE_URL_BUS_TRACKING || "http://bus.asiatech.ptp",
  //TODO: update all env and ask about production
  pathname: process.env.NEXT_PUBLIC_BASE_PATHNAME,
  CDN_IMAGE: `${
    process.env.NEXT_PUBLIC_BASE_URL_STORE || "https://store.snapptrip.co"
  }/assets/airlines/57x57/`,
  SeoGeolocation: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/json/seo-geo-cities-data.json`,
  SeoContentApi: `${process.env.NEXT_PUBLIC_BASE_URL_HAPI}/service2/seo/seo/page/element`,
  Announcements: `${process.env.NEXT_PUBLIC_BASE_URL_HAPI}/announcement/announcements`,
  Airports: "/api/statics/v2/airports-cities",
  Airlines: "/api/statics/v1/airlines",
  SolutionDetail: "/api/listing/v1/detail",
  Detail: "/api/listing/v1/solution",
  Detailv2: "/dom-flights/v2/detail",
  LoadingAirlines: "/assets/json/dom-flights-loading-airlines.json",
  airlines: "/assets/airlines/48x48/",
  SnappCustomerInfo: "/api/customers/v2/info/",
  customerMetaData: "/passengers/v1/customer-metadata",
  CountryCodes: "/api/statics/v1/country-codes",
  Passenger: "/passengers/v1/passengers",
  Book: "/api/booking/v2/book",
  BookDom: "/dom-flights/v1/book",
  BookBus: "/bus2/api/booking/v1/user/book",
  visaUrl: "/api/visa/v2/order",
  // DOM FLIGHT
  DomFlightSolutionDetail: "/dom-flights/v1/detail",
  DomFlightPriceTable: "/price-table/oneway",
  DomFlightSearchOneWay: "/dom-flights/v1/one-way/search",
  DomFlightSearchRoundTrip: "/dom-flights/v1/return/search",
  // INTER FLIGHT
  InterFlightSearchOneWay: "/api/listing/v1/one-way/search",
  InterFlightSearchRoundTrip: "/api/listing/v1/return/search",
  InterFlightPriceTable: "/api/price-table/oneway",
  Visa: "/api/visa/v2/order",
  Banners: "/banners/v1/banner/active",
  OrderHistory: "/api/book/v1/history/summary",
  PriceAlert: "/api/buying-assistant/v1/price-alert",
  Reminders: "/flight-solution-notifier/reminders",
  baseUrlTrain:
    process.env.NEXT_PUBLIC_BASE_URL_TRAIN || "http://train-api.asiatech.ptp",
  trainCancellationDetail: "/ticketing/v2/detail",
  trainCancellationPolicy: "/api/ticketing/v2/user/cancellation-policies",
  trainRefundInfo: "/api/ticketing/v2/user/refund-info",
  trainSubmitRefund: "/api/ticketing/v2/user/refund-ticket",
  AutoReserve: "/auto-reserve",
  domFlightCancellationDetail: "/flights/api/v3/invoices",
  domFlightReviewPenalty: "/dom-flights/v1/cancellation/penalty/invoices",
  domFlightCancellationReasons: "/dom-flights/v1/cancellation/reasons",
  domFlightCancellationSubmit:
    "/dom-flights/invoices/tickets/cancellations/submit",
  busCancellationDetail: "/bus2/api/booking/v1/tickets/",
  busCancellationSubmit: "/bus2/api/booking/v1/tickets/cancel",
  busCancellationRule: "/bus2/api/booking/v1/cancellation-rules/html",
  intFlightCancellationReasons:
    "/api/book/v1/cancellation/cancellation-reasons",
  intFlightCancellationDetail: "/api/book/v1/orders/tracking",
  intFlightCancellationSubmit: "/api/book/v1/manual-cancellation",
  intFlightCancellationPassengers: "/api/book/v1/manual-cancellation",
  busSearch: "/bus-listing-go/v2/availability",
  ticketPriceList: `${process.env.NEXT_PUBLIC_BASE_URL_FLIGHT}/api/ticket-price-table/lookup`
};
